import { render } from "./MessagesDemo.vue?vue&type=template&id=352926e8&scoped=true"
import script from "./MessagesDemo.vue?vue&type=script&lang=js"
export * from "./MessagesDemo.vue?vue&type=script&lang=js"

import "./MessagesDemo.vue?vue&type=style&index=0&id=352926e8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352926e8"]])

export default __exports__